import type {ColumnsType} from "antd/es/table"
import {CategoryDTO} from "../../types/category/CategoryDTO";
import CategoryActionButton from "./action/CategoryActionButton";
import {Button} from "antd";

type UseColumnsProps = {
    showPicture: (pictureUrl: string | undefined) => void
}

type UseColumnsType = ({showPicture}: UseColumnsProps) => ColumnsType<CategoryDTO>

export const useColumns: UseColumnsType = ({showPicture}) => {

    const columns: ColumnsType<CategoryDTO> = [
        {
            title: "ИД",
            dataIndex: "id",
            key: "id",
        },
        {
            title: "Название категория",
            dataIndex: "name",
            key: "name"
        },
        {
            title: "Фото",
            dataIndex: "picture",
            key: "picture",
            render: (_, record) => <Button onClick={() => showPicture(record.picture_url)}>Посмотреть фото</Button>
        },
        {
            title: "Действие",
            dataIndex: "action",
            key: "action",
            align: 'center',
            render: (_, record) => <CategoryActionButton category={record}/>
        }
    ]

    return columns
}